import { render, staticRenderFns } from "./sqxy.vue?vue&type=template&id=3ecdc70d&scoped=true&"
import script from "./sqxy.vue?vue&type=script&lang=js&"
export * from "./sqxy.vue?vue&type=script&lang=js&"
import style0 from "./sqxy.vue?vue&type=style&index=0&id=3ecdc70d&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecdc70d",
  null
  
)

export default component.exports